"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getElementIdSelector = void 0;
// eslint-disable-next-line complexity
function getElementIdSelector(element, data) {
    switch (element) {
        case 'suggestion':
            return `suggestion-${data.id}`;
        case 'page':
            return `page${data.id}`;
        case 'label':
            return `label-${data.id}`;
        case 'question':
            return `q${data.id}`;
        case 'widget':
            return `w${data.id}`;
        case 'option':
        case 'key':
            return `q${data.id}o${data.optionId}`;
        case 'optionScale':
        case 'optionTable':
            return `q${data.id}op${data.optionId}`;
        default:
            return element;
    }
}
exports.getElementIdSelector = getElementIdSelector;
